// extracted by mini-css-extract-plugin
export default {"container":"AuthLayout_container__mhq0V","left":"AuthLayout_left__l68rr","right":"AuthLayout_right__Gdn3V","rightHeader":"AuthLayout_rightHeader__S2anb"};